import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbsUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconThumbsUp"><Path d="M6.5 10.5H2.5V20.5H6.5M6.5 10.5L11.0484 2.5H11.6605C12.8891 2.5 13.8273 3.59737 13.6362 4.81101L13.0161 8.75H18.4462C20.3042 8.75 21.7154 10.4217 21.4037 12.2534L20.4249 18.0034C20.1795 19.4453 18.9301 20.5 17.4675 20.5H6.5M6.5 10.5V20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconThumbsUp;
